<template>
<div>
    <h1>Done!</h1>
    <!-- <el-table ref="fileTable" :data="files" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column prop="entityName" label="Uploaded Asset" show-overflow-tooltip>
            <template slot-scope="scope">
                <el-popover trigger="hover" placement="top">{{scope.row.name}}
                    <p slot="reference">{{ scope.row.entityName }}</p>
                </el-popover>
            </template>
        </el-table-column>
        <el-table-column label="Meta" width="180">
            <template slot-scope="scope">
                <div slot="reference" class="name-wrapper">
                    <el-tag class="meta-tag" size="small">{{ scope.row.task }}</el-tag>
                    <el-tag class="meta-tag" v-if="scope.row.descriptor" size="small">{{ scope.row.descriptor }}</el-tag>
                    <el-tag class="meta-tag" size="small">{{ scope.row.version }}</el-tag>
                </div>
            </template>
        </el-table-column>
    </el-table> -->

    <div style="margin-top: 40px;"></div>
    <div v-if="playlist">
    <h2>Files Uploaded</h2>
    <p>Successfully uploaded {{files.length}} files</p>
    </div>
    <div v-if="playlist">
    <h2>Playlist Created</h2>
    <p>{{playlist.attributes.code}}</p>
    </div>
    <div v-if="note">
    <h2>Note Created</h2>
    <p>{{note.attributes.subject}}</p>
    </div>
    <el-button style="margin-top: 10px" plain type="success"  @click="uploadMore()">Upload More Files</el-button>
        <el-button style="margin-top: 10px" plain type="default"  @click="logout()">Log Out</el-button>
</div>
</template>

<script>
import { AUTH_LOGOUT } from "@/store/actions/auth";

export default {
  props: {
    files: Array,
    playlist: Object,
    note: Object
  },
  data() {
    return {
      multipleSelection: []
    };
  },

  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    uploadMore() {
      this.$router.go();
    },
    logout() {
      this.$store.dispatch(AUTH_LOGOUT);
      this.$router.replace("/login");
    }
  }
};
</script>

<style scoped>
.meta-tag {
  margin-right: 5px;
}
</style>
